import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Mixpanel from 'mixpanel-browser';
import Header from '~/components/Header';
import Quiz from '~/core/helpers/quiz';
import { ScreenProps, NavigationPath } from '~/core/dto/navigationDTO';

import './Home.styles.css';
import Spacer from '~/components/Spacer';

const Home: FC<ScreenProps> = ( { type } ) => {

  const navigate = useNavigate();
  const routeName = `Home-${type}`;
  const ages = Quiz.getAges( type );
  const isParent = type === 'parent';

  const onContinue = ( value: string ) => {

    Mixpanel.track( routeName, { state: 1 } );

    Quiz.saveAge( value, type );
    navigate( type === 'adult' ? NavigationPath.AdultIntro : NavigationPath.Intro );

  };

  useEffect( () => {

    Mixpanel.track( routeName, { state: 0 } );

  }, [] );

  return (
    <div className="container scrollContainer">
      <Header type={type} />
      <div className="scrollContainer homeContainer justifySpaceBetween">
        <div>
          <h1 className="textCenter">{!isParent ? 'Find out your financial IQ' : 'Start money conversations with your child'}</h1>
          <Spacer size={12} />
          <h3 className="textCenter">3-MINUTE QUIZ</h3>
          <Spacer size={24} />
          {isParent && <h2 className="textCenter">How old is your child?</h2>}
        </div>
        <div className="selectAge flexRow alignCenter justifyCenter">
          {ages.map( ( age ) => (
            <div key={age.id} onClick={() => onContinue( age.id )} aria-hidden className="selectAgeItem flexColumn alignCenter justifyCenter cursorPointer">
              <img src={age.image} alt={age.title} />
              <p>
                Age:&#160;
                {age.title}
              </p>
            </div>
          ) )}
        </div>
        <p className="homeFooterText textCenter">
          Tatrym Inc. 251 Little Falls Drive. New Castle County, Wilmington, Delaware 19808, US.
          &#160;
          <a href="https://www.birdwingo.com/wp-content/uploads/2023/09/Birdwingo-TCs.pdf">Terms & Conditions</a>
          .
          &#160;
          <a href="https://www.birdwingo.com/wp-content/uploads/2022/10/Birdwingo_Privacy-Policy-Updated.pdf">Privacy Policy</a>
        </p>
      </div>
    </div>
  );

};

export default Home;
